import { render } from "./idea_update_history.vue?vue&type=template&id=041c8ac3&scoped=true"
import script from "./idea_update_history.vue?vue&type=script&lang=js"
export * from "./idea_update_history.vue?vue&type=script&lang=js"

import "./idea_update_history.vue?vue&type=style&index=0&id=041c8ac3&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041c8ac3"]])

export default __exports__